import { DOMAIN_REGEX } from 'constants/regexp';

import * as yup from 'yup';

export const schema = yup.object().shape({
  merchantId: yup.string().required('app.validation.required'),
  currency: yup.string().required('app.validation.required'),
  country: yup.string().required('app.validation.required'),
  customerId: yup.string().required('app.validation.required'),
  direction: yup.string().required('app.validation.required'),
  language: yup.string().nullable(),
  countDeposit: yup.number().nullable(),
  appVersion: yup.string().nullable(),
  domain: yup.string().matches(DOMAIN_REGEX, { message: 'app.validation.wrongDomain' }).nullable(),
});
